<template>
  <div class="wrap padden main display-flex">
      <div class="logo">
          <img src="../assets/Spryntr-logo.svg" alt="">
      </div>
      <nav>
          <ul>
              <li>
                  <router-link to='/'>Home</router-link>
              </li>
              <li>
                  <router-link to='/'>Feedback</router-link>
              </li>
               <li>
                  <router-link to="/">Blog</router-link>
              </li>
               <li>
                  <router-link to="/">Contact</router-link>
              </li>
          </ul>
      </nav>
      <div @click='openNavBar()' class="menu">
         <img src="../assets/menu.svg" alt="">   
      </div>
  </div>
</template>

<script>
export default {
 name: 'Header',
 methods:{
     openNavBar(){
         this.$emit('open')
     }
 }
}
</script>

<style lang="scss" scoped>
.wrap{
    padding:25px 0px;
	nav {
		width: 30%;
		ul {
			display: flex;
			align-items: center;
			justify-content: space-between;
			li {
				font-family: 'DM Sans', sans-serif;
				cursor: pointer;
				list-style-type: none;
				font-size: 1em;
				a {
					text-decoration: none;
					color: #ffffff;
				}
			}
		}
	}
    .menu{
        display: none;
    }
}

@media (max-width:980px){
    .wrap{
        flex-direction: row;
        nav{
            display: none;
        }
        .menu{
            display: block;
            width:38px;
            img{
                width:100%;
            }

        }
    }
}
</style>